import { memo } from 'react';
import useProgressiveImg from '../hooks/ProgressiveImg';

const ProgressiveImg = ({ lowQualitySrc, highQualitySrc, style, ...props}) => {

  const [src, { blur }] = useProgressiveImg(lowQualitySrc, highQualitySrc);
  return (
    <img
      src={src}
      alt={'image_load'}
      style={{
        ...style,
        filter: blur ? "blur(5px)" : "none",
        transition: blur ? "none" : "filter 0.3s ease-out"
      }}
      {...props}
    />
  );
};

export default memo(ProgressiveImg);